import { useEffect, useState } from 'react';
import axios from 'axios';
import { apiHost } from '../../utils/apiHost';

// Promo untuk keranjang kasir web: POST /promo/hitung (server menghitung; transaksi sebenarnya dihitung ulang server).
// items: [{ baranguuid, total }] (total = harga x jumlah sebelum promo). opsi: { kodeKupon, customerUuid } — kupon yang diketik kasir dan
// pelanggan terdaftar yang dipilih (promo ulang tahun, batas per pelanggan). Mengembalikan { diskonTotal, promoNama, kupon, kuponGalat }:
// diskonTotal = potongan promo otomatis + kupon; promoNama = "Promo + Kupon KODE" (untuk struk); kuponGalat = alasan kode tidak bisa dipakai.
// Gagal / paket tanpa promo / keranjang kosong = tanpa potongan. Ditunda 300 ms supaya tidak memanggil server tiap ketukan.
const base = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};

const KOSONG = { diskonTotal: 0, promoNama: '', kupon: null, kuponGalat: '' };

/** "Promo A + Kupon KODE" dari balasan /promo/hitung (nama sama dengan yang disimpan server di transaksi). */
export const namaPromoGabungan = (d) => [d?.promo?.nama, d?.kupon ? `Kupon ${d.kupon.kode}` : ''].filter(Boolean).join(' + ');

export const usePromoKeranjang = (items, opsi = {}) => {
  const [hasil, setHasil] = useState(KOSONG);
  const kunci = JSON.stringify(items || []);
  const kode = String(opsi.kodeKupon || '').trim();
  const pelanggan = opsi.customerUuid || '';

  useEffect(() => {
    const daftar = JSON.parse(kunci);
    if (daftar.length === 0) { setHasil(KOSONG); return undefined; }
    let batal = false;
    const t = setTimeout(() => {
      axios.post(`${base()}/promo/hitung`, { items: daftar, ...(kode ? { kodeKupon: kode } : {}), ...(pelanggan ? { customerUuid: pelanggan } : {}) }, { withCredentials: true })
        .then((r) => {
          if (batal) return;
          const d = r.data?.data;
          setHasil({
            diskonTotal: Number(d?.diskonTotal) || 0,
            promoNama: namaPromoGabungan(d),
            kupon: d?.kupon || null,
            kuponGalat: d?.kuponGalat || '',
          });
        })
        .catch(() => { if (!batal) setHasil(KOSONG); });
    }, 300);
    return () => { batal = true; clearTimeout(t); };
  }, [kunci, kode, pelanggan]);

  return hasil;
};
